import { render, staticRenderFns } from "./WhatsappsAndEmails.vue?vue&type=template&id=0d48f225&scoped=true"
import script from "./WhatsappsAndEmails.vue?vue&type=script&lang=js"
export * from "./WhatsappsAndEmails.vue?vue&type=script&lang=js"
import style0 from "./WhatsappsAndEmails.vue?vue&type=style&index=0&id=0d48f225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48f225",
  null
  
)

export default component.exports